import { useState,  useEffect, createRef } from 'react';
import Config from '../Config';

function Odwolanie(props)
{

    const [view, setView] = useState('btn');
    const [id, setId] = useState(props.id);    

    const zmienGodzine = (e) => {
        setView("dialog");
    }

    const zamknij = (e) => {
        e.target.innerHTML = "...";
        setView("btn");
    }


    const zapisz = (e) => {
       
        e.target.innerHTML = "...";

        var dt = {   
            id: id,
            opcja: 'cancel',
            param: ''
        }
    
        fetch( Config.url + '/rest_public,video_change_status', {
            method: 'POST', 
            body: JSON.stringify(dt), 
            headers: {
                'Content-Type': 'text/html',
                'X-API-KEY': props.apiKey
            }
         })
         .then(res => res.json() )
         .then(res => {                       
         
                if(res.status == 'OK')
                {
                    alert("Prezentacja została odwołana.");
                    props.onDateChange( '' );
                }else
                {
                    alert("Aktualnie nie możesz odwołać prezentacji. Spróbuj później.");  
                }
    
         } )
         .catch(err => {
            console.log("Err " + err);
         });
              

    }


  

    if(view == 'btn')
    {
        return <span className='btn btn_red' onClick={zmienGodzine}>Zrezygnuj</span>
    }

    return (
        <div className='dialog_termin'>
                <div className='dialog_window'>
                        <div className='label'>Czy na pewno chcesz odwołać prezentacje?</div>
                        <div className='content'>
 

                        </div>
                        <div className='buttons'>
                            <span className='simply_link' onClick={zapisz}>Tak</span>
                            &nbsp;&nbsp; &nbsp;&nbsp; 
                            &nbsp;&nbsp; &nbsp;&nbsp; 
                            <span className='simply_link' onClick={zamknij}>Nie</span>                                                      
                        </div>
                </div>
        </div>
    )
}


export default Odwolanie;